import React, { useEffect, useState } from "react";
import CVGeneratorForm from "./cv-generator";
import Breadcrumb from "../../common/BreadCrumb";
import DownloadCv from "../../common/downloadCv";
import EditCvPopup from "../../common/edit-cv-popup";
import { useNavigate } from "react-router-dom";

const CVReview = ({ toggleCV, cvData, cv_id }) => {
  const navigate = useNavigate();
  const [showEditPopup, setShowEditPopup] = useState(false);
  const breadcrumbItems = [
    { name: "Dashboard", link: "/dashboard" },
    { name: "CV Generator", link: "/cv-generator" },
    { name: "CV Review", link: "/cv-review" },
  ];
  if (cvData === null) {
    return (
      <>
        <section id="dash">
          <Breadcrumb items={breadcrumbItems} />
          <div className="contain">
            <div className="dash_new_txt text-center">
              <h3>✨ CV is not Ready!</h3>
            </div>
          </div>
        </section>
      </>
    );
  }
  return (
    <>
      <section id="dash">
        <Breadcrumb items={breadcrumbItems} />
        <div className="contain">
          <div className="dash_new_txt text-center">
            <h3>✨ Your Tailored CV is Ready!</h3>
            <p>Review the optimizations and download your enhanced CV</p>
          </div>
          <div className="outer_cmn_blk_dash cv_review_blk">
            <div className="cmn_blk_new_dash">
              <div className="flex">
                <div className="col">
                  <div className="top_head">
                    <div className="image_icon">
                      <img src="/images/cv-generator/tick.svg" alt="" />
                    </div>
                    <div className="r_txt">
                      <h4 className="heading_dash">CV Optimizations</h4>
                      <p>
                        {cvData.optimizations?.length || 0} improvements made
                      </p>
                    </div>
                  </div>
                  <ul className="style_ul">
                    {/* <li>
                                <div className="icon_li">
                                    <img src="/images/cv-generator/key.svg" alt="" />
                                </div>
                                <div className="txt_r">
                                    <p>Keywords Added</p>
                                    <p><small>Added 12 relevant keywords: "Python", "Machine Learning",</small></p>
                                </div>
                            </li>
                            <li>
                                <div className="icon_li">
                                    <img src="/images/cv-generator/skill.svg" alt="" />
                                </div>
                                <div className="txt_r">
                                    <p>Skills Section Enhanced</p>
                                    <p><small>Reorganized skills to match job requirements priority</small></p>
                                </div>
                            </li>
                            <li>
                                <div className="icon_li">
                                    <img src="/images/cv-generator/achi.svg" alt="" />
                                </div>
                                <div className="txt_r">
                                    <p>Achievements Quantified</p>
                                    <p><small>Added measurable results to 5 work experience points</small></p>
                                </div>
                            </li>
                            <li>
                                <div className="icon_li">
                                    <img src="/images/cv-generator/summary.svg" alt="" />
                                </div>
                                <div className="txt_r">
                                    <p>Summary Updated</p>
                                    <p><small>Professional summary tailored to highlight relevant experience</small></p>
                                </div>
                            </li>
                            <li>
                                <div className="icon_li">
                                    <img src="/images/cv-generator/certificate.svg" alt="" />
                                </div>
                                <div className="txt_r">
                                    <p>Certifications Highlighted</p>
                                    <p><small>Moved relevant certifications to prominent position</small></p>
                                </div>
                            </li> */}
                    {cvData.optimizations?.map((opt, i) => (
                      <li key={i}>
                        <div className="icon_li">
                          <img src="/images/cv-generator/key.svg" alt="" />
                        </div>
                        <div className="txt_r">
                          <p>{opt.title}</p>
                          <p>
                            <small>{opt.description}</small>
                          </p>
                        </div>
                      </li>
                    ))}
                  </ul>
                  <div className="score-card">
                    <div className="score-header">
                      <span className="title">ATS Compatibility Score</span>
                      <span className="score">{cvData.job_match_score}%</span>
                    </div>
                    <div className="progress-bar">
                      <div
                        className="progress-fill"
                        style={{ width: `${cvData.job_match_score}%` }}
                      ></div>
                    </div>
                    <p className="description">
                      {cvData.job_match_score > 80
                        ? "Excellent! Your CV is highly optimized for applicant tracking systems."
                        : "Your CV could benefit from further optimization."}
                    </p>
                  </div>
                </div>
                <div className="col">
                  {showEditPopup && (
                    <EditCvPopup
                      handleClose={() => setShowEditPopup(false)}
                      cvDetails={cvData}
                      cv_id={cv_id}
                      onSuccess={() => navigate("/my-cvs")}
                    />
                  )}
                  <div className="top_head">
                    <div className="image_icon">
                      <img src="/images/cv-generator/pdf.svg" alt="" />
                    </div>
                    <div className="r_txt">
                      <h4 className="heading_dash">Final CV Preview</h4>
                      <p>Optimized for {cvData.current_title} role</p>
                    </div>
                    <div className="btn_blk ct_btns">
                      <button
                        type="button"
                        className="site_btn black sm"
                        onClick={() => setShowEditPopup(true)}
                      >
                        <img src="/images/cv-generator/edit-ico.svg" alt="" />
                        <span>Edit</span>
                      </button>
                      {/* <button type="button" className="site_btn sm">
                                    <img src="/images/cv-generator/download.svg" alt="" />
                                    <span>Download</span>
                                </button> */}
                      <DownloadCv
                        cv_id={cv_id}
                        small_btn={true}
                        btn_title="Download"
                      />
                    </div>
                  </div>
                  <div className="cv_disply_blk">
                    <div className="cv_head">
                      <h4>{cvData.name}</h4>
                      <p>{cvData.current_title}</p>
                      <p>
                        <small>
                          {cvData.email} | {cvData.phone} | {cvData.location}
                        </small>
                      </p>
                    </div>
                    <div className="cv_bdy">
                      {/* <div className="blk_cv">
                                    <h5>PROFESSIONAL SUMMARY</h5>
                                    <p>Experienced Software Engineer with 5+ years developing scalable web applications using Python, React, and AWS. Proven track record of delivering high-quality solutions in Agile environments, with expertise in machine learning implementation and cloud architecture.</p>
                                </div>
                                <div className="blk_cv">
                                    <h5>KEY SKILLS</h5>
                                    <p>Python • Machine Learning • AWS • React • Agile • Docker • JavaScript • Node.js • PostgreSQL • Git</p>
                                </div>
                                 <div className="blk_cv">
                                    <h5>PROFESSIONAL EXPERIENCE</h5>
                                    <div className="experience_blk">
                                        <div className="inner_experience">
                                            <div className="head_exp">
                                                <h6>Senior Software Engineer</h6>
                                                <p>2021 - Present</p>
                                            </div>
                                            <p>TechCorp Ltd, London</p>
                                            <ul>
                                                <li>Led development of microservices architecture serving 100k+ daily users</li>
                                                <li>Implemented ML algorithms reducing processing time by 40%</li>
                                                <li>Mentored 5 junior developers and conducted code reviews</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div> */}
                      <div className="blk_cv">
                        <h5>PROFESSIONAL SUMMARY</h5>
                        <p>{cvData.professional_summary}</p>
                      </div>
                      <div className="blk_cv">
                        <h5>KEY SKILLS</h5>
                        <p>{cvData.key_skills?.join(" • ")}</p>
                      </div>
                      <div className="blk_cv">
                        <h5>PROFESSIONAL EXPERIENCE</h5>
                        {cvData.work_experience?.map((exp, i) => (
                          <div className="experience_blk" key={i}>
                            <div className="inner_experience">
                              <div className="head_exp">
                                <h6>{exp.job_title}</h6>
                                <p>
                                  {exp.start_date} - {exp.end_date}
                                </p>
                              </div>
                              <p>
                                {exp.company}, {exp.location}
                              </p>
                              <ul>
                                {exp.responsibilities?.map((r, idx) => (
                                  <li key={idx}>{r}</li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="blk_cv">
                        <h5>EDUCATION</h5>
                        {cvData.education?.map((edu, i) => (
                          <div key={i}>
                            <p>
                              <span>{edu.degree}</span> – {edu.institution},{" "}
                              {edu.location} ({edu.start_year} - {edu.end_year})
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="btns_bar btn_blk">
                <button
                  type="button"
                  className="site_btn grey"
                  onClick={toggleCV}
                >
                  <img src="/images/cv-generator/back.svg" alt="" />
                  <span>Back to Generator</span>
                </button>
                <div className="btn_blk text-right">
                  {/* <button type="button" className="site_btn blank">
                            <img src="/images/cv-generator/save.svg" alt="" />
                            <span>Save CV</span>
                        </button> */}
                  <DownloadCv cv_id={cv_id} btn_title="Download PDF" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CVReview;
